import { createContext, useState, useContext, useEffect } from 'react';
import arTranslations from '../locales/ar.json';
import enTranslations from '../locales/en.json';

const LanguageContext = createContext();

// دالة لاستخراج لغة المتصفح (ar أو en)
const getBrowserLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'ar' ? 'ar' : 'en';
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // تهيئة اللغة: أولوية للغة المخزنة، ثم لغة المتصفح، ثم 'ar' كقيمة افتراضية
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && (savedLanguage === 'ar' || savedLanguage === 'en')) {
      return savedLanguage;
    }
    return getBrowserLanguage();
  });

  const translations = {
    ar: arTranslations,
    en: enTranslations
  };

  // حفظ اللغة في localStorage كلما تغيرت
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prevLang => prevLang === 'ar' ? 'en' : 'ar');
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value === undefined) return key; // إرجاع المفتاح إذا لم يوجد الترجمة
      value = value[k];
    }
    
    return value !== undefined ? value : key;
  };

  const value = {
    language,
    toggleLanguage,
    t,
    dir: language === 'ar' ? 'rtl' : 'ltr'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};